import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {  useAlert } from "../../../hooks/useAlert";
import { Col, Row, Form } from "react-bootstrap";
import AlertMessage from "../../../components/AlertMessage";
import ImprovementPlanStatusPieChart from "../components/dashboard/ImprovementPlanStatusPieChart";
import { RootState } from "../../../redux/store";
import { setFilterByCurrentUser } from "../../../redux/filtersSlice";
import ImprovementPlanStatusAndTypeBarChart from "../components/dashboard/ImprovementPlanStatusAndTypeBarChart";
import { ImprovementPlanIndicators } from "../components/dashboard/ImprovementPlanIndicators";
import { useOutletContext } from "react-router-dom";
import { DashboardImprovementPlansOutletContext } from "../../../components/Layouts/ImprovementPlansDashboardLayout";
export default function ImprovementPlanDashboard() {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const [message, setMessage] = useState<string | undefined>();
    const { alert, hideAlert, showAlert, isVisible } = useAlert({ fromLocation: false });
    const { filterByCurrentUser } = useSelector((state: RootState) => state.filters.improvementPlans);
    const { section1Ref, section2Ref } = useOutletContext<DashboardImprovementPlansOutletContext>();
    useEffect(() => {
        if (!message) return;
        showAlert({
            message: message,
            type: 'danger',
            duration: 8000
        });

    }, [message, showAlert]);

    const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setFilterByCurrentUser({ table: 'improvementPlans', filterByCurrentUser: e.target.checked }));
    }

    return (<>
        <Form>
            <Form.Check
                className="my-4"
                type="switch"
                id="custom-switch"
                label={t("common:buttons.toggleAssignUser")}
                checked={filterByCurrentUser}
                onChange={handleToggle}
            />
        </Form>
        <Row>
            <Col className="text-center" xs={12} md={12}>
                {isVisible && (
                    <AlertMessage
                        message={alert!.message}
                        type={alert!.type}
                        onClose={hideAlert}
                    />
                )}
            </Col>
        </Row>
        <Row ref={section1Ref}>
            <Col className="text-center mb-3" xs={12} md={12}>
                <ImprovementPlanIndicators setMessage={setMessage} />
            </Col>
        </Row>
        <Row ref={section2Ref}>
            <Col xs={6} >
                <ImprovementPlanStatusPieChart setMessage={setMessage} />
            </Col>
            <Col xs={6}>
                <ImprovementPlanStatusAndTypeBarChart setMessage={setMessage} />
            </Col>
        </Row>
    </>
    );
}